/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Funnel_Sq_Fr3_BodyInputs */

const en_funnel_sq_fr3_body = /** @type {(inputs: Funnel_Sq_Fr3_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PDFs, scanned pages, web articles, even a photo of a physical page. Heard something worth keeping? One tap saves the last two sentences straight to your notes.`)
};

const es_funnel_sq_fr3_body = /** @type {(inputs: Funnel_Sq_Fr3_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PDF, páginas escaneadas, artículos web e incluso la foto de una página impresa. ¿Escuchaste algo que vale la pena guardar? Con un toque guardas las dos últimas frases directamente en tus notas.`)
};

/**
* | output |
* | --- |
* | "PDFs, scanned pages, web articles, even a photo of a physical page. Heard something worth keeping? One tap saves the last two sentences straight to your notes." |
*
* @param {Funnel_Sq_Fr3_BodyInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const funnel_sq_fr3_body = /** @type {((inputs?: Funnel_Sq_Fr3_BodyInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Funnel_Sq_Fr3_BodyInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_funnel_sq_fr3_body(inputs)
	return en_funnel_sq_fr3_body(inputs)
});